<div class="barrados" role="status" *ngIf="credores.length > 0">
  <p class="barrados__titulo">
    <i class="fas fa-lock" aria-hidden="true"></i>
    {{ credores.length === 1 ? 'Um acesso ficou bloqueado' : credores.length + ' acessos ficaram bloqueados' }}
  </p>
  <p class="barrados__texto">
    O seu IP<ng-container *ngIf="ip"> <span class="barrados__ip">{{ ip }}</span></ng-container>
    não está liberado em:
  </p>
  <ul class="barrados__lista">
    <li *ngFor="let credor of credores">{{ credor }}</li>
  </ul>
  <p class="barrados__texto barrados__texto--rodape">
    Para entrar {{ credores.length === 1 ? 'nele' : 'neles' }}, peça ao administrador do credor para liberar este IP.
  </p>
</div>
